import { makeStyles, Typography } from "@material-ui/core";
import React from "react";

type TitleProp = {
  children: React.ReactNode;
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 20,
    color: theme.palette.primary.main,
    width: "100%",
    fontWeight: "bold",
  },
}));

export const Title = ({ children }: TitleProp) => {
  const classes = useStyles();
  return (
    <Typography variant="h5" className={classes.root}>
      {children}
    </Typography>
  );
};
